import { useState, useEffect } from 'react';

type ColorScheme = 'light' | 'dark' | 'auto';

const COLOR_SCHEME_KEY = 'yochien-ai-color-scheme';

export function useColorScheme() {
  // Get initial color scheme from localStorage or default to 'light'
  const getInitialColorScheme = (): ColorScheme => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(COLOR_SCHEME_KEY);
      if (stored === 'dark' || stored === 'light') {
        return stored;
      }
      // Check system preference
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
      }
    }
    return 'light';
  };

  const [colorScheme, setColorScheme] = useState<ColorScheme>(getInitialColorScheme);

  const toggleColorScheme = (value?: ColorScheme) => {
    const nextColorScheme = value || (colorScheme === 'dark' ? 'light' : 'dark');
    setColorScheme(nextColorScheme);
    localStorage.setItem(COLOR_SCHEME_KEY, nextColorScheme);
  };

  // Listen for system color scheme changes
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e: MediaQueryListEvent) => {
      const stored = localStorage.getItem(COLOR_SCHEME_KEY);
      if (!stored) {
        setColorScheme(e.matches ? 'dark' : 'light');
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return { colorScheme, toggleColorScheme };
}